import { fromJS } from "immutable";
import * as ActionTypes from "../../actions/cart/types";
import { mapCartItem } from "../../types/cart/map";

const INITIAL_STATE = {
    cartItems: [],
    lastAddedItem: null,
    pendingNotificationItem: null,
    shouldShowLastAddedNotification: false,
    count: 0,
    vat: 0,
    sum: 0,

    addresses: [],
    carriers: [],
    ciCarriers: [],
    countries: [],

    loading: false,
    message: null,
    shouldRefreshCart: false,
};

const ensureImmutable = (state) => {
    if (!state) return fromJS(INITIAL_STATE);
    if (typeof state.get === "function") return state;
    return fromJS(state);
};

function setCartMessage(state, action) {
    state = ensureImmutable(state);

    const message = action.payload;

    return state.set(
        "message",
        fromJS(
            message
                ? {
                    text: message?.text,
                    variant: message?.variant,
                }
                : null
        )
    );
}

function getCart(state) {
    state = ensureImmutable(state);

    return state
        .set("loading", true)
        .set("message", null);
}

function getCartSucceeded(state, action) {
    state = ensureImmutable(state);

    const data = action.payload?.data || {};
    const items = Array.isArray(data.items)
        ? data.items.map((item) => mapCartItem(item))
        : [];

    return state
        .set("loading", false)
        .set("message", null)
        .set("cartItems", fromJS(items))
        .set("count", Number(data.count) || 0)
        .set("vat", Number(data.VAT) || 0)
        .set("sum", Number(data.sum) || 0)
        .set("total", Number(data.total) || 0)
        .set("addresses", fromJS(data.addresses || []))
        .set("carriers", fromJS(data.carriers || []))
        .set("ciCarriers", fromJS(data.CIcarriers || []))
        .set("countries", fromJS(data.countries || []));
}

function getCartFailed(state, action) {
    state = ensureImmutable(state);

    const { message } = action.payload || {};

    return state
        .set("loading", false)
        .set(
            "message",
            fromJS({
                text: message || "get_cart_failed",
                variant: "error",
            })
        );
}

function editCart(state, action) {
    state = ensureImmutable(state);

    const payload = action.payload || {};
    const { id, quantity, product,suppressNotification  } = payload;

    const cartItems = state.get("cartItems");
    const existingItem = cartItems.find((item) => item.get("id") === String(id));

    const itemForLastAdded =
        product ? fromJS(product) : (existingItem || null);

    return state
        .set("loading", true)
        .set("message", null)
        .set("pendingNotificationItem", itemForLastAdded)
        .set("shouldShowLastAddedNotification", !suppressNotification);
}

function editCartSucceeded(state, action) {
    state = ensureImmutable(state);

    const pendingNotificationItem = state.get("pendingNotificationItem");

    return state
        .set("loading", false)
        .set("message", null)
        .set("lastAddedItem", pendingNotificationItem || null)
        .set("pendingNotificationItem", null)
        .set("shouldRefreshCart", true);
}

function editCartFailed(state, action) {
    state = ensureImmutable(state);

    const { message } = action.payload || {};

    return state
        .set("loading", false)
        .set("pendingNotificationItem", null)
        .set("shouldRefreshCart", false)
        .set(
            "message",
            fromJS({
                text: message || "edit_cart_failed",
                variant: "error",
            })
        );
}

function clearCart(state) {
    state = ensureImmutable(state);

    return state
        .set("cartItems", fromJS([]))
        .set("lastAddedItem", null)
        .set("message", null)
        .set("loading", false);
}

function clearLastAdded(state) {
    state = ensureImmutable(state);

    return state
        .set("lastAddedItem", null)
        .set("pendingNotificationItem", null)
        .set("shouldShowLastAddedNotification", false);
}

function ackCartRefresh(state) {
    state = ensureImmutable(state);

    return state.set("shouldRefreshCart", false);
}

const cart = {
    initialState: INITIAL_STATE,
    handlers: {
        [ActionTypes.SET_CART_MESSAGE]: setCartMessage,

        [ActionTypes.CART_GET]: getCart,
        [ActionTypes.CART_GET_SUCCEEDED]: getCartSucceeded,
        [ActionTypes.CART_GET_FAILED]: getCartFailed,

        [ActionTypes.CART_EDIT]: editCart,
        [ActionTypes.CART_EDIT_SUCCEEDED]: editCartSucceeded,
        [ActionTypes.CART_EDIT_FAILED]: editCartFailed,

        [ActionTypes.CART_CLEAR_CART]: clearCart,
        [ActionTypes.CART_CLEAR_LAST_ADDED]: clearLastAdded,
        [ActionTypes.CART_ACK_REFRESH]: ackCartRefresh,
    },
};

export default cart;

export const CartModule = {
    name: "cart",
    reducer: cart,
};